import { useEffect } from "react";
import useFixedAcceptorEmail from "./useFixedAcceptorEmail";
import { constants } from "entities/RequestBasicDetails";

const { additionalAcceptanceFieldStateDefaultValues } = constants.basicDetails;

const defaultOptions = {
  shouldDirty: true,
  shouldValidate: true,
};

const useAdvancePaymentFieldController = (
  form,
  validations,
  dependencies,
  advancePayment,
  setAdditionalAcceptorFieldState,
  requestorEmail,
  representation = null
) => {
  const { setValue, resetField, watch } = form;

  const costCentre = watch("cost_centre");
  const supervisorEmail = watch("supervisor_email");
  const advancePaymentAmount = watch("advance_payment");
  const additionalAcceptorEmail = watch("additional_acceptor_email");

  const advancePaymentAcceptorTresholdAmount =
    validations?.advance_payment_rules?.additional_acceptor_threshold;
  const advancePaymentAcceptorEmail =
    representation?.additional_acceptor_email === "N/A"
      ? dependencies.additional_acceptor_email
      : representation?.additional_acceptor_email;
  const advancePaymentSupervisorEmail =
    representation?.manager_email === "N/A"
      ? dependencies.manager_email
      : representation?.manager_email;

  const fixedAcceptorEmail = useFixedAcceptorEmail(costCentre, [
    supervisorEmail,
    requestorEmail,
  ]);

  useEffect(() => {
    if (advancePayment) {
      if (!supervisorEmail) {
        setValue(
          "supervisor_email",
          advancePaymentSupervisorEmail,
          defaultOptions
        );
      }
      setAdditionalAcceptorFieldState((prev) => ({
        ...prev,
        disabled: true,
      }));
      if (additionalAcceptorEmail !== null) {
        setAdditionalAcceptorFieldState((prev) => ({
          ...prev,
          open: true,
        }));
      }
    } else {
      resetField("advance_payment");
      if (fixedAcceptorEmail) {
        setValue(
          "additional_acceptor_email",
          fixedAcceptorEmail,
          defaultOptions
        );
      }
    }

    if (!advancePaymentAcceptorTresholdAmount || !advancePaymentAcceptorEmail)
      return;

    if (advancePaymentAmount > advancePaymentAcceptorTresholdAmount) {
      setAdditionalAcceptorFieldState((prev) => ({
        ...prev,
        open: true,
      }));
      setValue(
        "additional_acceptor_email",
        advancePaymentAcceptorEmail,
        defaultOptions
      );
    } else if (!fixedAcceptorEmail) {
      resetField("additional_acceptor_email");
      setAdditionalAcceptorFieldState(
        additionalAcceptanceFieldStateDefaultValues
      );
    }
  }, [
    advancePaymentAmount,
    advancePaymentAcceptorTresholdAmount,
    advancePaymentAcceptorEmail,
    advancePaymentSupervisorEmail,
    advancePayment,
    representation,
    dependencies,
    fixedAcceptorEmail,
  ]);
};

export default useAdvancePaymentFieldController;
